/**
 * Vanilla JS implementation of the accordion component
 * used in Loomis.Corporate.Html. project
 *
 * This replicates the Stimulus controller behavior from:
 * ~\Loomis.Corporate.Html\src\js\controllers\accordion.js
 *
 * This version avoids adding Stimulus to keep bundle size small,
 * since no other Stimulus-based components are currently planned.
 *
 * If more Stimulus components are introduced in the future,
 * consider replacing this with the original Stimulus controller
 * for consistency and maintainability.
 */

function b_accordion_init() {
  const accordions = document.querySelectorAll('[data-controller="accordion"]');

  accordions.forEach(accordion => {
    const triggers = accordion.querySelectorAll('.b-accordion__item__title');

    triggers.forEach(trigger => {
      trigger.addEventListener('click', event => {
        const item = event.currentTarget.closest('.b-accordion__item');
        const closeIcon = item.querySelector('.b-accordion__icon-close');
        const plusIcon = item.querySelector('.b-accordion__icon-plus');

        const isExpanded = item.getAttribute('aria-expanded') === 'true';

        item.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');

        if (closeIcon && plusIcon) {
          closeIcon.classList.toggle('visible', !isExpanded);
          plusIcon.classList.toggle('visible', isExpanded);
        }
      });
    });
  });
}

b_accordion_init();

export default b_accordion_init;
  